import React, {useState} from 'react';
import {DropDownFlex, FormField, FormLayout, Input, SimpleButton, Textarea} from "@tag/tag-components-react-v4";
import ContactService from "../services/ContactService";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";

const Contact = () => {
    const {accounts, inProgress} = useMsal();
    const isAuthenticated = useIsAuthenticated();
    
    const [typeValue, setTypeValue] = useState<string|undefined>();
    const [messageValue, setMessageValue] = useState<string|undefined>();
    const [messageSent, setMessageSent] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    
    const isSubmitDisabled = () => {
        if (!typeValue ||
            !messageValue)
        {
            return true;
        }
        return false;
    }
    
    const sendContact = () => {
        if (typeValue && messageValue) {

            const messasgeAsHtml = messageValue
                .replace(/\n/g, '<br />\n')
                .replace(/^(.*)$/gm, '<p>$1</p>');

            ContactService.sendContact(typeValue, messasgeAsHtml, accounts[0].username)
                .then(() => {
                    setMessageSent(true);
                })
                .catch(() => {
                    setError(true);
                });
        }
    }
    
    let content = null;
    if (error) {
        content = (
            content = <h3
                style={{color: 'red'}}
            >An error has occured and your message was not sent, please contact HSC Care DevOps</h3>
        )
    }
    else if (!messageSent) {
        content = (
            <FormLayout columns={6} rows={3}>
                <FormField
                    label="Message Type"
                    labelProps={{style: {margin: 'auto'}}}
                    editor={
                        <DropDownFlex
                            data={
                                [
                                    'Query',
                                    'Suggestions',
                                    'Bugs',
                                    'Praise'
                                ]
                            }
                            onChange={(e) => {
                                setTypeValue((e.target as HTMLSelectElement).value)
                            }}
                        />
                    }
                    required
                    invalid={!typeValue && typeValue != undefined}
                    validationErrors="Please select a message type"
                    column={3}
                    row={3}
                    columnSpan={2}
                />
                <FormField
                    label="Message"
                    labelProps={{style: {margin: 'auto'}}}
                    editor={<Textarea style={{height: '16em'}} />}
                    onChange={(e) => setMessageValue((e.target as HTMLInputElement).value)}
                    required
                    invalid={!messageValue && messageValue != undefined}
                    validationErrors="Please enter a message"
                    column={2}
                    row={4}
                    columnSpan={4}
                />
                <div style={{ gridRowStart: '5', gridRowEnd: 'span 1', gridColumnStart: '3', gridColumnEnd: 'span 2' }}>
                    <SimpleButton disabled={isSubmitDisabled()}
                        onClick={() => sendContact()}
                    >Submit</SimpleButton>
                </div>
            </FormLayout>
        );
    }
    else {
        content = <h3>Thank you - your message has been received</h3>
    }

    return (
        <>
            <h1>Leave a Message</h1>
            {content}
        </>
    );
}

export default Contact;
